import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useEffect} from 'react'
import s from './error-page.scss'

export const ErrorPage = ({viewMode}: {viewMode: string}) => {
  const isSite = viewMode === 'Site'
  const {t} = useTranslation()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    window.location.reload()
  }

  useEffect(() => {
    document.getElementById('events-error-screen').setAttribute('data-hydrated', 'true')
  }, [])

  return (
    <div dir="ltr" id="events-error-screen">
      <div className={s.container}>
        <div className={s.box}>
          <h2 className={s.title}>{t('viewerWidget.errorState.title')}</h2>
          <p className={s.subtitle}>{t('viewerWidget.errorState.subtitle')}</p>
          {isSite ? (
            <button className={s.button} onClick={handleClick}>
              {t('viewerWidget.errorState.button')}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
